import dispatcher from "../Dispatcher/Dispatcher";
import { EventEmitter } from "events";
import ConfigValidationConstants from "../Constants/ConfigurationValidationConstants";

let resultData = null;

class ConfigurationValidationStore extends EventEmitter {
  emitChange(eventName) {
    this.emit(eventName);
  }
  getResult() {
    return resultData;
  }
  setResult(_result) {
    resultData = _result;
  }
  addChangeListener(eventName, callback) {
    this.on(eventName, callback);
  }

  removeChangeListener(eventName, callback) {
    this.removeListener(eventName, callback);
  }
  handleCallback(action) {
    switch (action.type) {
      case ConfigValidationConstants.GET_CONFIG_VALIDATION_SUCCESS:
        this.setResult(action.result);
        break;
      case ConfigValidationConstants.GET_CONFIG_VALIDATIONT_FAILURE:
        this.setResult(action.result);
        break;
      default:
        break;
    }
    this.emitChange(action.type);
    return true;
  }
}

const configurationValidationStore = new ConfigurationValidationStore();
dispatcher.register(
  configurationValidationStore.handleCallback.bind(configurationValidationStore)
);
export default configurationValidationStore;
